import React, { createContext, useCallback, useContext, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const notify = useCallback(({ message, severity = 'info' }) => {
    setNotification({ open: true, message: message || '', severity });
  }, []);

  const hide = useCallback(() => {
    setNotification((prev) => ({ ...prev, open: false }));
  }, []);

  return (
    <NotificationContext.Provider value={notify}>
      {children}
      <Snackbar
        open={notification.open}
        autoHideDuration={notification.severity === 'error' ? 6000 : 3500}
        onClose={hide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      >
        <Alert
          onClose={hide}
          severity={notification.severity}
          variant="filled"
          sx={{ minWidth: 280 }}
        >
          {notification.message}
        </Alert>
      </Snackbar>
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const notify = useContext(NotificationContext);
  if (!notify) throw new Error('useNotification must be used within NotificationProvider');
  return notify;
};
